// 用户模块
export default {
    namespaced: true,
    state () {
      return {
        permissionList: [],
        permissionData: [],
        menuData:[],
        styleData:{}
      }
    },
    mutations: {
        // 修改权限信息
        setPermissionList (state, payload) {
          state.permissionData = payload;
          state.permissionList = filterAsyncMenu(payload)
        },

        // 修改菜单信息
        setmenuData (state, payload) {
          state.menuData = payload
        },

         // 修改风格信息
         setStyleData (state, payload) {
          state.styleData = payload
        },
        
    },
    actions:{
      // 获取权限信息
      getPermissionList(context,payload){
        context.commit('setPermissionList',payload)
      },
    },
    getters:{

    }
}

// 过滤菜单拼装数组对象
function filterAsyncMenu(list){
 const data = list;
 var tree = [];
 for(let d in data){
  const item = data[d];
  let parentId = item.parentMenuId;
  // M 目录, C 菜单, F 按钮
  if(item.type=='F'){
    // 寻找他的上层数据，获取路由
    // if(parentId){
    //     const index = findIndex(data,{id:parentId});
    //     const ParemtIndex = findIndex(tree,{id:parentId});
    //     // 判断是否已经存在
    //     if(ParemtIndex==-1){
    //       tree.push( {id:data[index].id,path:data[index].path,permissionList:[item.permissionIdentification]});
    //     }else{
    //       tree[ParemtIndex].permissionList.push(item.permissionIdentification)
    //     }
        
    // }

    // 直接拼接按钮权限表
    tree.push(item.permissionIdentification);
  }
 };
 return tree;
}